exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IconCircleClose_iconClose__3H6ND:hover{fill:#c2c2c2}.IconCircleClose_iconClose__3H6ND:active{fill:#999}", ""]);

// exports
exports.locals = {
	"iconClose": "IconCircleClose_iconClose__3H6ND"
};